export const tr = {
    'add-button-text': 'Ekle',
    'add-button-text-with-count': 'Ekle, {count}',
    'add-correction': 'Yeni düzenleme'
};
